import React from 'react'
import { ChatbotStepActionData, retrieveContactActionData } from '../../../../models/flowBuilderTypes';
import { Grid, Typography } from '@mui/material';
import globalStyles from "../../../../assets/styles/global.module.scss";
import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import clsx from "clsx";
import { getRetrieveContactValueText } from '../flowBuilderConstants';

interface RetrieveContactNodeProps {
    id: string, 
    data: ChatbotStepActionData<retrieveContactActionData>
} 

const RetrieveContactNode: React.FC<RetrieveContactNodeProps> = (props) => {
    
    const { id, data } = props;

    return (
        <>
            <Grid item>
                <Grid container className={clsx(globalStyles.displayFlexStyle, globalStyles.flexColumn)}>
                    <Grid item>
                        <Typography className={formStyles.dataSavedTextStyle}>
                            Retrieve Contact
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={formStyles.dataSavedValueStyle}>
                            {getRetrieveContactValueText(data?.action_data)}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default RetrieveContactNode
